// src/pages/Tasas.jsx
import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AOS from 'aos';
import { Table } from 'react-bootstrap';
import { getRates } from '../services/rates';
import 'aos/dist/aos.css'; // Asegúrate de importar los estilos de AOS

const Tasas = () => {
  const [rates, setRates] = useState({
    vesRate: null,
    usdCopRate: null,
    copUsdRate: null
  });
  const [lastUpdate, setLastUpdate] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });

    const fetchRates = async () => {
      try {
        const data = await getRates();
        setRates({
          vesRate: data.vesRate || null,
          usdCopRate: data.usdCopRate || null,
          copUsdRate: data.copUsdRate || null
        });
        setLastUpdate(new Date().toLocaleTimeString());
      } catch (error) {
        console.error("Error obteniendo tasas:", error);
      }
    };

    fetchRates();
  }, []);

  // Función para formatear números a dos decimales
  const formatRate = (rate) => {
    if (rate === null) return 'Cargando...';
    return parseFloat(rate).toFixed(2);
  };


  return (
    <>
      <Header />
      <section className="hero-section" id="hero-tasas">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8" data-aos="fade-right">
              <h1>Tasas de Cambio en Tiempo Real</h1>
              <p className="mb-4">
                Consulta las tasas actualizadas para las principales divisas: USD, Euros, Bs, COP y más.
              </p>
            </div>
            <div className="col-lg-4" data-aos="fade-left">
              <img src="/assets/img/exchange.png" alt="Tasas de Cambio" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section className="section">
          <div className="container">
            <h2 className="mb-4 text-center">Tabla de Tasas</h2>
            <div className="table-responsive my-3">
              <Table responsive striped bordered hover size="sm" className="align-middle text-center custom-table">
                <thead className="table-dark">
                  <tr>
                    <th>Divisa</th>
                    <th>Tasa Actual</th>
                    <th>Última actualización</th>
                  </tr>
                </thead>
                <tbody>
                  {/* <tr data-aos="fade-up">
                    <td>USD/EUR</td>
                    <td>0</td>
                    <td>{lastUpdate || 'Cargando...'}</td>
                  </tr> */}
                  <tr data-aos="fade-up" data-aos-delay="100">
                    <td>USD/Bs</td>
                    <td>{formatRate(rates.vesRate)}</td>
                    <td>{lastUpdate || 'Cargando...'}</td>
                  </tr>
                  <tr data-aos="fade-up" data-aos-delay="200">
                    <td>USD/COP</td>
                    <td>{formatRate(rates.usdCopRate)}</td>
                    <td>{lastUpdate || 'Cargando...'}</td>
                  </tr>
                  <tr data-aos="fade-up" data-aos-delay="300">
                    <td>COP/USD</td>
                    <td>{formatRate(rates.copUsdRate)}</td>
                    <td>{lastUpdate || 'Cargando...'}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      {/* Estilos personalizados para la tabla */}
      <style jsx>{`
        .custom-table tbody tr {
          transition: background-color 0.3s ease;
          cursor: pointer;
        }
        .custom-table tbody tr:hover {
          background-color: #f8f9fa;
        }
      `}</style>
    </>
  );
};

export default Tasas;
